export const getPrice = (payments, currency) => {
    if(payments?.exchanges?.length) {
      return payments?.exchanges.reduce((total, el)=>total + el.exchangeValues?.[currency?.toLowerCase()]?.value, 0 )
    }
    return payments?.exchange?.exchangeValues?.[currency?.toLowerCase()]?.value || 0
}

export const sumPaymentsPrice = (obj, currency)=>  obj.reduce((total, el)=>total + getPrice(el.payments, currency), 0 )


export const sumExchangeValues = (exchanges) => {
  if (!exchanges || !Array.isArray(exchanges)) return null;
  
  const totalSum = exchanges.reduce((total, exchange) => {
    const values = exchange.exchangeValues || {};
    Object.entries(values).forEach(([currency, data]) => {
      if (!total.value && data.isOriginValue) {
        total.value = (total.value || 0) + (data.value || 0);
        total.valueBase = Math.floor(total.value);
        total.dolarBase = (total.dolarBase || 0) + exchange.dolarBase;
      }
      
      if (!total.exchangeValues[currency]) {
        total.exchangeValues[currency] = {
          value: 0,
          factor: data.factor,
          isOriginValue: data.isOriginValue
        };
      }
      total.exchangeValues[currency].value += data.value || 0;
    });
    return total;
  }, {
    value: 0,
    valueBase: 0,
    dolarBase: 0,
    exchangeValues: {}
  });

  return totalSum;
};